var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M16.667 18c0-1.163 0-1.744-.143-2.218a3.33 3.33 0 0 0-2.222-2.222c-.474-.143-1.055-.143-2.218-.143H7.917c-1.163 0-1.744 0-2.217.143a3.33 3.33 0 0 0-2.222 2.222c-.144.474-.144 1.055-.144 2.218M13.751 6.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0"
  })));
};
export default SvgPerson;